export enum SignupActionTypes {
  SET_SIGNUP_DATAVALUE = "SET_SIGNUP_DATAVALUE",
  SET_SIGNUP_ISLOADING = "SET_SIGNUP_ISLOADING",
  SET_SIGNUP_USER_EXISTS_ALREADY = "SET_SIGNUP_USER_EXISTS_ALREADY",
  SET_SIGNUP_MSG = "SET_SIGNUP_MSG",
  SET_SIGNUP_NEWSLETTER = "SET_SIGNUP_NEWSLETTER",
}
